module.exports = __webpack_public_path__ + "assets/opinionlab.6993e8ef.svg";